module.exports = __webpack_public_path__ + "images/touch-icon-iphone-retina.eec256c8fabbdedf64013760ef396d98.png";